import { Headset, HardHat, AppWindow, Laptop } from '@phosphor-icons/react'

export const Icons = {
  Headset,
  HardHat,
  AppWindow,
  Laptop,
}
